import React, { useContext } from 'react'
// import {makeStyles} from '@material-ui/core'
import { DataContext } from '../dataContext'

// const useStyles = {
//   container: {
//     display: 'flex', 
//     alignItems: 'center', 
//     gap: 5, 
//     color: '#333'
//   },  
//   live: {
//     backgroundColor: 'red', 
//     color: 'white', 
//     fontWeight: 'bold', 
//     textTransform: 'uppercase', 
//     padding: '0px 5px', 
//     height: 22, 
//     lineHeight: '22px', 
//     textAlign: 'center', 
//     borderRadius: 5, 
//     fontSize: 11
//   }, 
//   time: {
//     fontSize: 11, 
//   }
// }

export default function LiveUpdates({time, className}) {
  const {data} = useContext(DataContext)
  const {
    UPDATETEXT
  } = data.STRINGS

  const isLive = () => {
    let timeDate = new Date(time)
    let now = new Date()

    if (timeDate.toLocaleDateString() === now.toLocaleDateString()) {
      return true
    }
    return false
  }


  const getDate = (update) => {
		const date = new Date(update)
    const dateString = isLive() ? "" : ` - ${date.toLocaleDateString(`${data.lang}-GB`,{year: 'numeric', month: 'long', day: 'numeric' })}` 

    return date.toLocaleTimeString(`en-US`, {timeZoneName: 'short'}) + dateString
    // return [dateArray[4], ' ', dateArray[6][1], dateArray[7][0], dateArray[8][0]].join('')
	}
  return (
    <div className={`${className} flex items-center gap-1 text-xs py-1`} id="LiveUpdate" tabIndex="0" aria-labelledby="liveUpdateText">
      {isLive() && <div className={'bg-globalred text-white rounded px-1 text-sm font-bold uppercase '}>Live</div>  }
      <div id="liveUpdateText" className={'classes.time'}>{UPDATETEXT}: {getDate(time)}</div>
    </div>
  )
}
